module.exports = function() {
  return new Worker(__webpack_public_path__ + "9116ea7e9e6eae25f6d9.worker.js");
};